import angular = require("angular");
import resourcesRoutes = require("./resources.routes");
import personsController = require("./persons.controller");
import personsEditController = require("./persons.edit.controller");
import personsNewController = require("./persons.new.controller");
import personWorkplacesController = require("./person.workplaces.edit.controller");
import personDetailsDirective = require("./person.details.directive");



export function initialize() {

    var resourcesModule = angular
        .module("app.resources", [
            "ui.router", "ui.router.upgrade"
        ]);

    resourcesRoutes.initialize(resourcesModule);
    personsController.initialize(resourcesModule);
    personsEditController.initialize(resourcesModule);
    personsNewController.initialize(resourcesModule);
    personWorkplacesController.initialize(resourcesModule);

    personDetailsDirective.initialize(resourcesModule);
}


import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import SharedModule from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { ComponentsModule } from "../components/components.installer";
import { ColorPickerModule } from 'ngx-color-picker';

import { UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import * as states from "./resources.states";

import { PersonComponentsModule } from "./persons/persons.module";

import { WorkGroupsComponent } from "./workgroups/work-groups.component";
import { WorkGroupComponent } from "./workgroups/work-group.component";
import { EditWorkGroupComponent } from "./workgroups/work-group.edit.component";

let STATES = [/*states.resourcesState, */states.workGroupsState, states.workGroupState, states.editWorkGroupState, states.newWorkGroupState];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        PersonComponentsModule,
        FlexLayoutModule,
        ComponentsModule,
        UIRouterModule.forChild({ states: STATES }),
        ColorPickerModule
    ],
    declarations: [WorkGroupsComponent, WorkGroupComponent, EditWorkGroupComponent]
})
export class ResourcesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/resources.module.ts